<template>
  <!-- Intro Template       **************************** -->
  <div v-show="slide.template == 'introsummary'">
    <v-card class="lessoncard" style="height: 100%" elevation="0">
      <v-card-title class="justify-center">
        <h1>
          {{ slide.pageTitle }}
        </h1>
      </v-card-title>

      <p>
        {{ slide.textArea }}
      </p>
      <p
        style="margin-top: 50px"
        v-if="slide.body && slide.display !== 'imageDeck'"
        v-html="slide.body"
      ></p>

      <div v-for="(caption, i) in slide.caption" :key="i">
        <v-card-text class="intro" v-show="caption">
          > {{ caption }}
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["slide"],
};
</script>
<style scoped>
.lessoncard {
  max-width: 80%;
  margin: auto;
}
.intro {
  font-weight: bold;
  font-size: 10rem;
  color: #415370;
}
h2 {
  text-align: center;
  color: #415370;
}
.margin-top {
  margin-top: 50px;
}
</style>
